<template lang="html">
  <v-btn
    flat
    icon
    :disabled="disabled"
    :color="color"
    @click="$emit('click', $event)">
    <v-icon>
      {{ icon }}
    </v-icon>
  </v-btn>
</template>

<script>
export default {
  props: {
    disabled: { type: Boolean, required: false, default: false },
    color: { type: String, required: false, default: 'primary' },
    icon: { type: String, required: true }
  }
}
</script>

<style lang="css" scoped>
</style>
